<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row>
        <el-col :span="2">
          <el-select v-model="is_yuangong" placeholder="是否员工" size="mini" @change="keywordsSearch">
            <el-option
              v-for="item in yuangong_status"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="4" :lg="4">
          <el-input placeholder="手机号" v-model="mobile" clearable @clear="keywordsSearch" @keyup.enter.native="keywordsSearch" size="mini">
            <el-button slot="append" icon="el-icon-search" @click="keywordsSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="4" :lg="4">
          <el-input placeholder="姓名" v-model="name" clearable @clear="keywordsSearch" @keyup.enter.native="keywordsSearch" size="mini">
            <el-button slot="append" icon="el-icon-search" @click="keywordsSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="9" :lg="9">
          <el-date-picker v-model="created" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="dateChange" format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd" size="mini">
          </el-date-picker>
          <el-button size="mini" type="primary" @click="exportData" v-loading="exportLoading" v-if="exportLoading == false">导出</el-button>
          <el-button size="mini" type="primary" v-loading="exportLoading" element-loading-text="拼命导出中..." v-else>导出</el-button>
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表-优选会员’页面中查看及下载数据">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </el-col>
      </el-row>
      <el-dialog title="报表下载" :visible.sync="downloadView" :close-on-click-modal="false">
        <template v-if="downloadUrl">
          <a :href="downloadUrl" download>{{downloadName}}</a>
        </template>
      </el-dialog>
      <el-table :data="memberData" :height="wheight-210"  v-loading="loading" @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" label="全选"></el-table-column>
        <el-table-column prop="member_id" label="怡贝会员ID" width="130"></el-table-column>
        <el-table-column prop="store_id" label="所属门店ID" width="130"></el-table-column>
        <el-table-column prop="user_id"   label="怡康会员ID" width="130"></el-table-column>
        <el-table-column prop="name"  label="姓名" width="130"></el-table-column>
        <el-table-column prop="superior_id" label="上级ID" width="100"></el-table-column>
        <el-table-column prop="member_lv_name" label="会员等级" width="130"></el-table-column>
        <el-table-column prop="mobile"  label="手机号" width="130"></el-table-column>
        <el-table-column prop="nickname"  label="会员昵称" width="130"></el-table-column>
        <el-table-column prop="sex" label="性别" width="50">
          <template slot-scope="scope">
            <span v-if="scope.row.sex=='2'">女</span>
            <span v-else-if="scope.row.sex=='1'">男</span>
            <span v-else>未知</span>
          </template>
        </el-table-column>
        <el-table-column prop="is_yuangong" label="是否员工" width="80">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.is_yuangong" active-value="1" inactive-value="0" @change="acitonYuangong(scope.$index, scope.row)" active-color="#13ce66" inactive-color="#dadadd"></></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="is_bail" label="是否已缴保证金" width="80">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.is_bail" active-value="1" inactive-value="0" @change="acitonBzj(scope.$index, scope.row)" active-color="#13ce66" inactive-color="#dadadd"></></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="regtime_date" label="注册时间" width="190"></el-table-column>
        <el-table-column label="操作" width="380">
          <template slot-scope="scope">
            <el-button type="text" @click="getDetail(scope.row.member_id)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="total_count > params.pageSize" class="content-padded tc">
        <el-pagination background   layout="prev, pager, next, total" @current-change="handleCurrentChange" :current-page.sync="params.page" :total='total_count' :page-size='params.pageSize'>
        </el-pagination>
      </div>
    </div>
    <router-view></router-view>
  </div>

</template>

<script>
import {membersList, updateMembersInfo, membersExport} from '../../../api/sharer'
import {mapGetters} from "vuex";
export default {
  data () {
    return {
      loading: false,
      exportLoading: false,
      memberData: [],
      params: {
        page: 1,
        pageSize: 20
      },
      total_count: 0,
      downloadView: false,
      downloadUrl: '',
      downloadName: '',
      mobile: '',
      name: '',
      created: '',
      is_yuangong: '',
      yuangong_status: [{
        value: '',
        label: '全部'
      }, {
        value: '1',
        label: '员工'
      }, {
        value: '0',
        label: '非员工'
      }],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    getMembers(filter) {
      this.loading = true
      membersList(filter).then(response => {
        this.memberData = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.loading = false
        this.exportLoading = false
      })
    },
    getDetail(member_id) {
      this.$router.push({
        path: this.matchHidePage('detail'),
        query: {
          member_id: member_id,
          currentPage: this.params.page
        }
      })
    },
    handleSelectionChange(val) {
      console.log(val)
    },
    handleCurrentChange(val) {
      this.params.page = val
      this.getMembers(this.params)
    },
    getParams () {
      this.params.mobile = this.mobile
      this.params.name = this.name
      this.params.is_yuangong = this.is_yuangong
    },
    dateChange (val) {
      if (val && val.length > 0) {
        this.params.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
        this.params.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
      } else {
        this.params.time_start_begin = ''
        this.params.time_start_end = ''
      }
      this.params.page = 1
      // console.log(this.params)
      this.getMembers(this.params)
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str)) / 1000
    },
    keywordsSearch (e) {
      this.params.page = 1
      this.getParams()
      this.getMembers(this.params)
    },
    acitonYuangong (index, row) {
      if (row.is_yuangong === '0') {
        var msg = '此操作将会取消员工认证，是否继续?'
      }else{
        var msg = '此操作将会将用户认证为员工，是否继续?'
      }
      this.$confirm( msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          'member_id': row.member_id,
          'is_yuangong': row.is_yuangong
        }
        updateMembersInfo(params).then(res => {
          this.getParams()
          this.getMembers(this.params)
        })
      }).catch(()=> {
        row.is_yuangong = row.is_yuangong === '0' ? '1' : '0'
      })
    },
    acitonBzj (index, row) {
      var msg = '此操作将会改变员工保证金缴纳状态，是否继续?'
      this.$confirm( msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          'member_id': row.member_id,
          'is_bail': row.is_bail
        }
        updateMembersInfo(params).then(res => {
          this.getParams()
          this.getMembers(this.params)
        })
      }).catch(()=> {
        row.is_bail = row.is_bail === '0' ? '1' : '0'
      })
    },
    exportData () {
      this.getParams()
      this.exportLoading = true
      membersExport(this.params).then(response => {
        this.exportLoading = false
        if (response.data.status) {
          this.$message({
            type: 'success',
            message: '已加入执行队列，请在设置-导出列表-优选会员中下载'
          })
          return
        } else if (response.data.url) {
          this.downloadUrl = response.data.url
          this.downloadName = response.data.filename
          this.downloadView = true
        } else {
          this.$message({
            type: 'error',
            message: '无内容可导出 或 执行失败，请检查重试'
          })
          return
        }
      })
    }
  },
  mounted () {
    this.getMembers(this.params)
    let param = {
      page: 1,
      pageSize: 100
    }
  },
  watch: {
    // 分页全选-监听数据变化
    memberData: {
      handler (value) {
        if (this.allCheck) {

          this.memberData.forEach(row => {
            if (row) {
              this.$refs.multipleTable.toggleRowSelection(row, true)
            }
          });
        }
      },
      deep: true
    },
  }
}
</script>



// WEBPACK FOOTER //
// list.vue?3433aed1